import { __rest } from "tslib";
import React from 'react';
const GalleryContext = React.createContext({});
export const GalleryProvider = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const galleryUI = rest.customComponents.EXPERIMENTAL_customGalleryUI;
    return React.createElement(GalleryContext.Provider, { value: { galleryUI } }, children);
};
export const useGalleryUI = () => {
    const { galleryUI } = React.useContext(GalleryContext);
    return galleryUI;
};
//# sourceMappingURL=GalleryContext.js.map